// Funil horizontal — barras decrescentes mostrando taxa de retenção etapa-a-etapa.
// Cada etapa tem largura proporcional à anterior + label de % de conversão.
import { chartTheme } from "./theme.ts";
import { fmtNum } from "../../lib/format.ts";

interface Stage {
  label: string;
  value: number;
}

interface Props {
  stages: Stage[];
  formatValue?: (v: number) => string;
}

export function FunnelBars({ stages, formatValue = fmtNum }: Props) {
  if (!stages.length) return <div className="center-loading">sem dados</div>;
  const t = chartTheme();
  const maxValue = Math.max(...stages.map((s) => s.value), 1);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: ".6rem" }}>
      {stages.map((s, i) => {
        const widthPct = Math.max((s.value / maxValue) * 100, 1);
        const conv = i > 0 && stages[i - 1]!.value > 0
          ? ((s.value / stages[i - 1]!.value) * 100).toFixed(1)
          : null;
        const color = i === 0 ? t.primary
                     : i === stages.length - 1 ? "#047857"
                     : t.primary;
        return (
          <div key={i}>
            <div style={{
              display: "flex", justifyContent: "space-between",
              fontSize: ".8rem", marginBottom: ".25rem",
            }}>
              <span style={{ fontWeight: 500 }}>{s.label}</span>
              <span className="mono" style={{ color: t.muted }}>
                {formatValue(s.value)}
                {conv !== null && (
                  <span style={{ marginLeft: ".5rem", color: t.muted }}>
                    · {conv}%
                  </span>
                )}
              </span>
            </div>
            <div style={{
              height: 18,
              background: t.grid,
              borderRadius: 3,
              overflow: "hidden",
              position: "relative",
            }}>
              <div style={{
                width: `${widthPct}%`,
                height: "100%",
                background: color,
                opacity: 0.85 + (i === stages.length - 1 ? 0.15 : 0),
                transition: "width .4s ease-out",
              }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
